/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Grid } from '@mui/material';
import useResponsive from '../../../../hooks/useResponsive';
import BuyScriptDrawer from './BuyScriptDrawer';
import EmptyWatchList from './components/EmptyWatchList';
import MobileWatchList from './components/MobileWatchList';
import DesktopWatchList from './components/DesktopWatchList';

const StaticWatchListItem = ({ filteredItems, user }) => {
  const isMobile = useResponsive('down', 'sm');
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedScript, setSelectedScript] = useState(null);

  // Handler for opening/closing the script drawer
  const toggleDrawer = (script) => {
    if (!script) {
      setShowDrawer((prevShowDrawer) => !prevShowDrawer);
      return;
    }

    if (user.role.rolename === 'client') {
      setSelectedScript(script);
      setShowDrawer((prevShowDrawer) => !prevShowDrawer);
    }
  };

  // Show empty state if no items
  if (filteredItems.length === 0) {
    return <EmptyWatchList />;
  }

  return (
    <Grid item xs={12} sx={{
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      height: filteredItems.length > 5 ? 'calc(100vh - 140px)' : 'auto'
    }}>
      {/* Render mobile or desktop view based on screen size */}
      {isMobile ? (
        <MobileWatchList
          filteredItems={filteredItems}
          toggleDrawer={toggleDrawer}
        />
      ) : (
        <DesktopWatchList
          filteredItems={filteredItems}
          toggleDrawer={toggleDrawer}
        />
      )}

      {/* Buy Script Drawer - shared between mobile and desktop */}
      {showDrawer && (
        <BuyScriptDrawer
          open={showDrawer}
          onClose={toggleDrawer}
          script={selectedScript}
          isMobile={isMobile}
        />
      )}
    </Grid>
  );
};

export default StaticWatchListItem;
